export default "__VITE_ASSET__d6399665__"